import React from "react";
import { Outlet } from "react-router-dom";
import MANAGEDATA_CONFIGURE from "../confrigration/constants";
import SideBar from "../admin/share/sideBar";
import Header from "../Adsy/share/Header";
import Footer from "../Adsy/share/Footer";
import "../Adsy/css/adsy.scss";

const AdsyLayout = () => {
  return (
    <div>
      <MANAGEDATA_CONFIGURE rankTableApi={false} />
      <div className="body_layout" style={{ height: "100vh" }}>
        <SideBar type={"adsyNavItem"} />
        <div className="layout_outlet" id="home_layout">
          <Header />
          <div className="home_layout">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default AdsyLayout;
